<div class="admin-bar">Admin — Editor de livros</div>
<app-menu></app-menu>
<app-login-validation (loggedIn)="onLoginValidated($event)"></app-login-validation>

<div class="page">
  <div class="container">
    <h1>Editor de livros &mdash; Editar livro #{{ idBookVersion }}</h1>
    <p class="subtitle">Edite todos os campos do livro, capas, arquivos e kits de venda.</p>

    <ng-container *ngIf="isLoading; else mainTpl">
      <div class="spinner">
        <mat-progress-spinner mode="indeterminate" diameter="56"></mat-progress-spinner>
      </div>
    </ng-container>

    <ng-template #mainTpl>

      <!-- ========= BLOQUEIO POR MARKETPLACE ========= -->
      <div class="marketplace-lock-banner" *ngIf="isLockedByMarketplace" role="alert">
        <mat-icon class="lock-icon">lock</mat-icon>
        <div>
          <strong>Edição bloqueada — livro sincronizado com marketplace.</strong><br />
          {{ marketplaceLockReason }}
        </div>
      </div>

      <!-- ========= USUÁRIO / AUTOR ========= -->
      <div class="user-picker-section">
        <h2 class="section-title" style="margin-bottom:4px;">Usuário / Autor</h2>
        <p class="subtitle">Conta do sistema vinculada a este livro</p>

        <!-- Usuário selecionado -->
        <div *ngIf="selectedUser; else userPickerTpl" class="selected-user">
          <mat-icon class="author-user-icon">account_circle</mat-icon>
          <div class="author-user-info">
            <div class="author-user-label">Usuário / Autor do sistema</div>
            <div class="author-user-name">{{ selectedUser.userName }}</div>
            <div class="author-user-email">{{ selectedUser.userEmail }}</div>
          </div>
          <div class="author-user-id">ID <strong>#{{ selectedUser.idUser }}</strong></div>
          <button mat-stroked-button type="button" class="trocar-btn" (click)="clearUser()" [disabled]="lockUserSelect">
            <mat-icon>swap_horiz</mat-icon> Trocar autor
          </button>
        </div>

        <!-- Seletor -->
        <ng-template #userPickerTpl>
          <div class="user-picker-row">
            <mat-form-field appearance="outline" class="user-search-field">
              <mat-label>Buscar usuário ativo</mat-label>
              <input matInput type="text"
                [matAutocomplete]="autoUser"
                [value]="userSearch"
                (input)="onUserSearch($any($event.target).value || '')"
                [disabled]="lockUserSelect" />
              <mat-autocomplete #autoUser="matAutocomplete"
                (optionSelected)="onUserSelected($event.option.value)">
                <mat-option *ngFor="let u of filteredUsers; trackBy: trackByUser" [value]="u">
                  {{ u.userName }} — {{ u.userEmail }}
                </mat-option>
                <mat-option *ngIf="filteredUsers.length === 0" disabled>
                  Nenhum usuário encontrado
                </mat-option>
              </mat-autocomplete>
              <mat-hint>Digite o nome ou e-mail para filtrar</mat-hint>
            </mat-form-field>

            <button type="button" class="icon-btn btn-green"
              matTooltip="Criar novo usuário"
              (click)="openCreateUserModal()">
              <mat-icon>person_add</mat-icon>
            </button>
          </div>
        </ng-template>
      </div>

      <form [formGroup]="model" (ngSubmit)="save()" [class.form-locked]="isLockedByMarketplace">

        <!-- ========= IDENTIFICAÇÃO ========= -->
        <h2 class="section-title">Identificação</h2>
        <p class="subtitle">Dados principais do livro</p>

        <div class="fields-row">
          <mat-form-field appearance="outline" class="field">
            <mat-label>Nome do autor (capa)</mat-label>
            <input matInput formControlName="coverAuthorName" />
            <mat-error *ngIf="model.controls['coverAuthorName'].invalid && model.controls['coverAuthorName'].touched">
              Campo obrigatório.
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="field">
            <mat-label>Título</mat-label>
            <input matInput formControlName="bookTitle" />
            <mat-error *ngIf="model.controls['bookTitle'].invalid && model.controls['bookTitle'].touched">
              Campo obrigatório.
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="field">
            <mat-label>Subtítulo</mat-label>
            <input matInput formControlName="bookSubtitle" />
          </mat-form-field>
        </div>

        <div class="fields-row">
          <mat-form-field appearance="outline" class="field">
            <mat-label>Edição / Versão</mat-label>
            <input matInput formControlName="versionName" />
            <mat-error *ngIf="model.controls['versionName'].invalid && model.controls['versionName'].touched">
              Campo obrigatório.
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="field">
            <mat-label>Nome da coleção</mat-label>
            <input matInput formControlName="collectionName" />
          </mat-form-field>

          <mat-form-field appearance="outline" class="field">
            <mat-label>Volume / número da coleção</mat-label>
            <input matInput formControlName="volumeName" />
          </mat-form-field>
        </div>

        <div class="fields-row">
          <mat-form-field appearance="outline" class="field">
            <mat-label>Total de páginas</mat-label>
            <input matInput type="number" formControlName="totalPages" />
            <mat-error *ngIf="model.controls['totalPages'].invalid && model.controls['totalPages'].touched">
              Informe um número válido (mínimo 1).
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="field col-12 col-md-6">
            <mat-label>ISBN</mat-label>
            <input matInput formControlName="isbn" maxlength="17" placeholder="978-85-0000-000-0" />
            <mat-hint>Somente números e hífens (10 ou 13 dígitos).</mat-hint>
            <mat-error *ngIf="model.controls['isbn'].invalid && (model.controls['isbn'].dirty || model.controls['isbn'].touched)">
              Informe um ISBN válido (10 ou 13 dígitos, pode conter hífens).
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="field col-12 col-md-6">
            <mat-label>DOI</mat-label>
            <input matInput formControlName="doi" maxlength="500" placeholder="10.1007/978-1-4842-3630-7" />
            <mat-hint>Identificador de Objeto Digital (DOI)</mat-hint>
          </mat-form-field>
        </div>

        <mat-form-field appearance="outline" class="synopsis-field">
          <mat-label>Sinópse (min. 500 e máx. 800 caracteres)</mat-label>
          <textarea matInput formControlName="synopsis" rows="4"></textarea>
          <mat-hint>{{ model.get('synopsis')?.value?.length || 0 }}/800</mat-hint>
          <mat-error *ngIf="model.get('synopsis')?.errors?.['minlength'] && model.get('synopsis')?.touched">
            Sinópse deve ter ao menos 500 caracteres.
          </mat-error>
          <mat-error *ngIf="model.get('synopsis')?.errors?.['maxlength'] && model.get('synopsis')?.touched">
            Sinópse deve ter no máximo 800 caracteres.
          </mat-error>
        </mat-form-field>
        <div class="char-counter" [class.over]="(model.get('synopsis')?.value?.length || 0) > 800">
          {{ model.get('synopsis')?.value?.length || 0 }} / 800
        </div>

        <mat-form-field appearance="outline" class="synopsis-field">
          <mat-label>Epígrafe (máx. 250 caracteres)</mat-label>
          <textarea matInput formControlName="preface" rows="3"></textarea>
          <mat-hint>{{ model.get('preface')?.value?.length || 0 }}/250</mat-hint>
          <mat-error *ngIf="model.get('preface')?.errors?.['maxlength'] && model.get('preface')?.touched">
            Epígrafe deve ter no máximo 250 caracteres.
          </mat-error>
        </mat-form-field>
        <div class="char-counter" [class.over]="(model.get('preface')?.value?.length || 0) > 250">
          {{ model.get('preface')?.value?.length || 0 }} / 250
        </div>

        <mat-form-field appearance="outline" class="synopsis-field">
          <mat-label>Texto da contracapa</mat-label>
          <textarea matInput formControlName="backCoverText" rows="3"></textarea>
        </mat-form-field>

        <!-- ========= CATEGORIAS ========= -->
        <h2 class="section-title">Categorias</h2>
        <p class="subtitle">Categorias primária e secundária</p>

        <div class="fields-row">
          <mat-form-field appearance="outline" class="field">
            <mat-label>Categoria primária</mat-label>
            <mat-select formControlName="idPrimaryCategory">
              <mat-option [value]="null" disabled>Selecione</mat-option>
              <ng-container *ngFor="let opt of primaryOptions; trackBy: trackByOption">
                <mat-option *ngIf="opt.isHeader" disabled>
                  <b style="color:#28a745;background:#f6f6f6;">{{ opt.label }}</b>
                </mat-option>
                <mat-option *ngIf="!opt.isHeader" [value]="opt.idCategory">
                  {{ opt.label }}
                </mat-option>
              </ng-container>
            </mat-select>
            <mat-error *ngIf="model.controls['idPrimaryCategory'].invalid && model.controls['idPrimaryCategory'].touched">
              Selecione uma categoria primária.
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="field">
            <mat-label>Categoria secundária</mat-label>
            <mat-select formControlName="idSecondaryCategory">
              <mat-option [value]="null" disabled>Selecione</mat-option>
              <ng-container *ngFor="let opt of secondaryOptions; trackBy: trackByOption">
                <mat-option *ngIf="opt.isHeader" disabled>{{ opt.label }}</mat-option>
                <mat-option *ngIf="!opt.isHeader" [value]="opt.idCategory">
                  {{ opt.label }}
                </mat-option>
              </ng-container>
            </mat-select>
            <mat-error *ngIf="model.controls['idSecondaryCategory'].invalid && model.controls['idSecondaryCategory'].touched">
              Selecione uma categoria secundária.
            </mat-error>
          </mat-form-field>
        </div>

        <!-- ========= AUTORES ========= -->
        <h2 class="section-title">Autores</h2>
        <p class="subtitle">Todos os autores envolvidos na construção do livro, incluindo o autor principal</p>

        <div formArrayName="listAuthors">
          <div class="authors-row" *ngFor="let ctrl of authors.controls; let i = index">
            <mat-form-field appearance="outline" class="author-field">
              <mat-label>Autor {{ i === 0 ? 'principal' : '' }}</mat-label>
              <input matInput [formControlName]="i" />
              <mat-error *ngIf="ctrl.invalid && ctrl.touched">Nome obrigatório.</mat-error>
            </mat-form-field>

            <button type="button" class="icon-btn btn-green" (click)="addAuthor()" matTooltip="Adicionar autor">
              <mat-icon>add</mat-icon>
            </button>
            <button type="button" class="icon-btn btn-red" *ngIf="authors.length > 1"
              (click)="removeAuthor(i)" matTooltip="Remover autor">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>

        <!-- ========= BIO + FOTO DO AUTOR ========= -->
        <h2 class="section-title" style="margin-top:28px;">Dados do autor</h2>
        <p class="subtitle">Biografia e foto (orelha da contracapa)</p>

        <div class="author-bio-row">
          <div class="author-photo-area">
            <div class="photo-drop-area" (drop)="onAuthorPhotoDrop($event)" (dragover)="onDragOver($event)">
              <ng-container *ngIf="!authorPhotoPreview; else authorPhotoTpl">
                <span>Arraste a foto do autor aqui<br />ou</span>
                <button type="button" mat-raised-button (click)="authorPhotoInput.click()">Selecionar foto</button>
                <input #authorPhotoInput type="file" accept="image/*" hidden (change)="onAuthorPhotoSelected($event)" />
                <ng-container *ngIf="existingAuthorPhotoUrl">
                  <a [href]="existingAuthorPhotoUrl" target="_blank" class="current-file-link">
                    <mat-icon style="font-size:16px;height:16px;width:16px;">photo</mat-icon>
                    Foto atual
                  </a>
                </ng-container>
              </ng-container>

              <ng-template #authorPhotoTpl>
                <img class="author-photo-preview" [src]="authorPhotoPreview" alt="Foto do Autor" [ngClass]="{
                    'photo-square': model.get('idPhotoShape')?.value === 1,
                    'photo-round': model.get('idPhotoShape')?.value === 2
                  }" />
                <button mat-stroked-button color="warn" type="button" (click)="clearAuthorPhoto()">
                  Remover
                </button>
              </ng-template>
            </div>

            <div class="photo-shape-options">
              <div class="shape-choice" [class.selected]="model.get('idPhotoShape')?.value === 1"
                (click)="model.patchValue({ idPhotoShape: 1 }); cdr.markForCheck()">
                <span class="icon-label">
                  <svg width="28" height="28">
                    <rect x="4" y="4" width="20" height="20" rx="5" fill="none" stroke="#28a745" stroke-width="3"></rect>
                  </svg>
                  <span>Quadrada</span>
                </span>
              </div>

              <div class="shape-choice" [class.selected]="model.get('idPhotoShape')?.value === 2"
                (click)="model.patchValue({ idPhotoShape: 2 }); cdr.markForCheck()">
                <span class="icon-label">
                  <svg width="28" height="28">
                    <circle cx="14" cy="14" r="10" fill="none" stroke="#28a745" stroke-width="3"></circle>
                  </svg>
                  <span>Redonda</span>
                </span>
              </div>
            </div>
          </div>

          <div class="author-bio-area">
            <mat-form-field appearance="outline" class="bio-field">
              <mat-label>Biografia do autor (máx. 4000 caracteres)</mat-label>
              <textarea matInput formControlName="authorBio" rows="8" maxlength="4000"></textarea>
              <mat-hint align="end">{{ model.get('authorBio')?.value?.length || 0 }}/4000</mat-hint>
              <mat-error *ngIf="model.get('authorBio')?.errors?.['required'] && model.get('authorBio')?.touched">
                Campo obrigatório.
              </mat-error>
              <mat-error *ngIf="model.get('authorBio')?.errors?.['maxlength'] && model.get('authorBio')?.touched">
                Biografia deve ter no máximo 4000 caracteres.
              </mat-error>
            </mat-form-field>
            <div class="char-counter" [class.over]="(model.get('authorBio')?.value?.length || 0) > 4000">
              {{ model.get('authorBio')?.value?.length || 0 }} / 4000
            </div>
          </div>
        </div>

        <!-- ========= TIPO DE IMPRESSÃO ========= -->
        <h2 class="section-title">Tipo de impressão</h2>
        <p class="subtitle">Selecione o tipo de impressão para cálculo de dimensões/peso.</p>

        <div class="print-table-wrap" *ngIf="listBookPrint?.length; else noPrintTpl">
          <table class="print-table">
            <thead>
              <tr>
                <th></th>
                <th>Tamanho</th>
                <th>Descrição</th>
                <th>Custo estimado</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let p of listBookPrint; trackBy: trackByPrint"
                [ngClass]="{ 'selected': model.get('idBookPrint')?.value === p.idBookPrint }"
                (click)="selectBookPrint(p.idBookPrint)">
                <td>
                  <input type="radio" [value]="p.idBookPrint" formControlName="idBookPrint" name="idBookPrint" />
                </td>
                <td>{{ p.bookPrintSize }}</td>
                <td>{{ p.bookPrintDescription }}</td>
                <td>R$ {{ (p.rawUnitCost || 0).toFixed(2) }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <ng-template #noPrintTpl>
          <div class="empty">
            Primeiro informe o total de páginas acima para carregar os tipos de impressão disponíveis.
          </div>
        </ng-template>

        <!-- ========= ARQUIVOS DO LIVRO ========= -->
        <h2 class="section-title">Arquivos do livro</h2>
        <p class="subtitle">Substitua apenas os arquivos que precisam ser atualizados. Arquivos não selecionados permanecem inalterados.</p>

        <div class="upload-grid">
          <!-- CAPA FRONTAL -->
          <div class="upload-card">
            <div class="upload-title">Capa (Front)</div>
            <div class="upload-box" (click)="frontCoverInput.click()">
              <ng-container *ngIf="frontCoverPreview; else frontCoverEmpty">
                <img class="upload-preview" [src]="frontCoverPreview" alt="Capa frontal" />
              </ng-container>
              <ng-template #frontCoverEmpty>
                <div class="empty-state">
                  <strong>Selecionar capa</strong>
                  <p>.jpg, .png, .webp</p>
                </div>
              </ng-template>
            </div>
            <input #frontCoverInput type="file" accept="image/*" hidden (change)="onFrontCoverSelected($event)" />
            <ng-container *ngIf="existingFrontCoverUrl && !frontCoverPreview">
              <a [href]="existingFrontCoverUrl" target="_blank" class="current-file-link">
                <mat-icon style="font-size:16px;height:16px;width:16px;">image</mat-icon>
                Capa atual
              </a>
            </ng-container>
            <button mat-button type="button" (click)="clearFrontCover()" *ngIf="frontCoverPreview">Remover</button>
            <mat-progress-spinner *ngIf="uploadLoading['frontCover']" mode="indeterminate" diameter="20"></mat-progress-spinner>
          </div>

          <!-- CONTRACAPA -->
          <div class="upload-card">
            <div class="upload-title">Contracapa (Back)</div>
            <div class="upload-box" (click)="backCoverInput.click()">
              <ng-container *ngIf="backCoverPreview; else backCoverEmpty">
                <img class="upload-preview" [src]="backCoverPreview" alt="Contracapa" />
              </ng-container>
              <ng-template #backCoverEmpty>
                <div class="empty-state">
                  <strong>Selecionar contracapa</strong>
                  <p>.jpg, .png, .webp</p>
                </div>
              </ng-template>
            </div>
            <input #backCoverInput type="file" accept="image/*" hidden (change)="onBackCoverSelected($event)" />
            <ng-container *ngIf="existingBackCoverUrl && !backCoverPreview">
              <a [href]="existingBackCoverUrl" target="_blank" class="current-file-link">
                <mat-icon style="font-size:16px;height:16px;width:16px;">image</mat-icon>
                Contracapa atual
              </a>
            </ng-container>
            <button mat-button type="button" (click)="clearBackCover()" *ngIf="backCoverPreview">Remover</button>
            <mat-progress-spinner *ngIf="uploadLoading['backCover']" mode="indeterminate" diameter="20"></mat-progress-spinner>
          </div>

          <!-- CAPA PARA IMPRESSÃO (PDF) -->
          <div class="upload-card">
            <div class="upload-title">Capa para impressão (PDF)</div>
            <div class="upload-box file" (click)="coverPrintInput.click()">
              <div class="empty-state" *ngIf="!coverForPrintLabel">
                <strong>Selecionar PDF</strong>
                <p>.pdf</p>
              </div>
              <div class="file-label" *ngIf="coverForPrintLabel">
                {{ coverForPrintLabel }}
              </div>
            </div>
            <input #coverPrintInput type="file" accept="application/pdf" hidden (change)="onCoverForPrintSelected($event)" />
            <ng-container *ngIf="existingCoverForPrintUrl && !coverForPrintLabel">
              <a [href]="existingCoverForPrintUrl" target="_blank" class="current-file-link">
                <mat-icon style="font-size:16px;height:16px;width:16px;">picture_as_pdf</mat-icon>
                Arquivo atual
              </a>
            </ng-container>
            <button mat-button type="button" (click)="clearCoverForPrint()" *ngIf="coverForPrintLabel">Remover</button>
            <mat-progress-spinner *ngIf="uploadLoading['coverForPrint']" mode="indeterminate" diameter="20"></mat-progress-spinner>
          </div>

          <!-- LIVRO PARA IMPRESSÃO (PDF) -->
          <div class="upload-card">
            <div class="upload-title">Livro para impressão (PDF)</div>
            <div class="upload-box file" (click)="bookPrintInput.click()">
              <div class="empty-state" *ngIf="!bookForPrintLabel">
                <strong>Selecionar PDF</strong>
                <p>.pdf</p>
              </div>
              <div class="file-label" *ngIf="bookForPrintLabel">
                {{ bookForPrintLabel }}
              </div>
            </div>
            <input #bookPrintInput type="file" accept="application/pdf" hidden (change)="onBookForPrintSelected($event)" />
            <ng-container *ngIf="existingBookForPrintUrl && !bookForPrintLabel">
              <a [href]="existingBookForPrintUrl" target="_blank" class="current-file-link">
                <mat-icon style="font-size:16px;height:16px;width:16px;">picture_as_pdf</mat-icon>
                Arquivo atual
              </a>
            </ng-container>
            <button mat-button type="button" (click)="clearBookForPrint()" *ngIf="bookForPrintLabel">Remover</button>
            <mat-progress-spinner *ngIf="uploadLoading['bookForPrint']" mode="indeterminate" diameter="20"></mat-progress-spinner>
          </div>

          <!-- E-BOOK (PDF) -->
          <div class="upload-card">
            <div class="upload-title">E-book (PDF)</div>
            <div class="upload-box file" (click)="ebookInput.click()">
              <div class="empty-state" *ngIf="!bookForEbookLabel">
                <strong>Selecionar PDF</strong>
                <p>.pdf</p>
              </div>
              <div class="file-label" *ngIf="bookForEbookLabel">
                {{ bookForEbookLabel }}
              </div>
            </div>
            <input #ebookInput type="file" accept="application/pdf" hidden (change)="onBookForEbookSelected($event)" />
            <ng-container *ngIf="existingEbookUrl && !bookForEbookLabel">
              <a [href]="existingEbookUrl" target="_blank" class="current-file-link">
                <mat-icon style="font-size:16px;height:16px;width:16px;">picture_as_pdf</mat-icon>
                E-book atual
              </a>
            </ng-container>
            <button mat-button type="button" (click)="clearBookForEbook()" *ngIf="bookForEbookLabel">Remover</button>
            <mat-progress-spinner *ngIf="uploadLoading['bookForEbook']" mode="indeterminate" diameter="20"></mat-progress-spinner>
          </div>
        </div>

        <!-- ========= STATUS DO LIVRO ========= -->
        <div class="status-danger-zone">
          <div class="danger-header">
            <mat-icon class="danger-icon">warning</mat-icon>
            <h2 class="section-title" style="margin:0;">Alterar status do livro</h2>
          </div>

          <div class="danger-alert">
            <mat-icon style="font-size:18px;height:18px;width:18px;vertical-align:middle;margin-right:6px;">report</mat-icon>
            <strong>Atenção — utilize com extrema cautela.</strong><br />
            Alterar o status do livro manualmente pode <strong>interromper o fluxo do autor</strong> caso ele esteja
            navegando pelo processo de publicação, causar <strong>comportamentos inesperados no sistema</strong> e
            deixar o livro em um estado inconsistente. Esta operação <strong>não pode ser desfeita automaticamente</strong>.
            Use somente quando tiver certeza absoluta da necessidade.
          </div>

          <div class="status-select-row">
            <mat-form-field appearance="outline" class="status-field">
              <mat-label>Novo status</mat-label>
              <mat-select
                [(ngModel)]="selectedStatusId"
                [ngModelOptions]="{ standalone: true }"
                [disabled]="isLockedByMarketplace"
                name="statusSelect">
                <mat-option
                  *ngFor="let s of listStatusVersion; trackBy: trackByStatus"
                  [value]="s.idStatusVersion"
                  [disabled]="s.idStatusVersion === PUBLISHED_STATUS_ID && !hasActiveKitWithItems">
                  {{ s.idStatusVersion }}. {{ s.statusVersionName }}
                  <span *ngIf="s.idStatusVersion === PUBLISHED_STATUS_ID && !hasActiveKitWithItems"
                        style="color:#b00020;font-size:.8rem;"> — requer kit ativo com itens</span>
                </mat-option>
              </mat-select>
            </mat-form-field>

            <div class="status-badge" *ngIf="originalStatusId">
              Status atual: <strong>{{ originalStatusId }}</strong>
            </div>
          </div>

          <div class="kit-warn" *ngIf="publishedStatusBlocked">
            <mat-icon style="font-size:16px;height:16px;width:16px;vertical-align:middle;">block</mat-icon>
            Para publicar, adicione ao menos um kit ativo com itens selecionados na seção abaixo.
          </div>
        </div>

        <!-- ========= MARKETPLACE (AMAZON) ========= -->
        <div class="marketplace-section" *ngIf="marketplace">
          <div class="marketplace-header">
            <h2 class="section-title" style="margin:0;">Marketplace (Amazon)</h2>
            <mat-slide-toggle
              color="primary"
              [checked]="marketplace.isMarketplaceEnabled"
              [disabled]="isTogglingMarketplace || (!marketplace.isMarketplaceEnabled && !marketplace.canEnable)"
              (change)="onToggleMarketplace($event)">
              Liberado para marketplace
            </mat-slide-toggle>
            <mat-progress-spinner *ngIf="isTogglingMarketplace" mode="indeterminate" diameter="18"></mat-progress-spinner>
          </div>

          <p class="subtitle" style="margin-top:6px;">
            Publica o livro físico na Amazon com o preço do kit de livro físico. Enquanto o livro estiver
            sincronizado, os dados do livro ficam bloqueados para edição.
          </p>

          <div class="marketplace-info">
            <div>
              Sincronizado com Base ERP:
              <span [ngClass]="marketplace.isSyncedToBase ? 'chip chip-sm chip-success' : 'chip chip-sm chip-warn'">
                {{ marketplace.isSyncedToBase ? 'Sim' : 'Não' }}
              </span>
            </div>
            <div *ngIf="marketplace.selectedKit; else noKitTpl">
              Kit usado no preço: <strong>{{ marketplace.selectedKit.kitName || ('Kit #' + marketplace.selectedKit.idKit) }}</strong>
              — {{ formatCurrency(marketplace.selectedKit.totalPrice) }}
            </div>
            <ng-template #noKitTpl><div>Kit usado no preço: <strong>nenhum kit com livro físico</strong></div></ng-template>
            <div *ngIf="marketplace.datetimeMarketplaceEnabled">
              Liberado em: {{ marketplace.datetimeMarketplaceEnabled | date:'dd/MM/yyyy HH:mm' }}
            </div>
          </div>

          <div class="kit-warn" *ngIf="!marketplace.isMarketplaceEnabled && marketplace.enableBlockReasons?.length">
            <mat-icon style="font-size:16px;height:16px;width:16px;vertical-align:middle;">block</mat-icon>
            Para liberar o livro para marketplace:
            <ul class="reasons-list">
              <li *ngFor="let r of marketplace.enableBlockReasons">{{ r }}</li>
            </ul>
          </div>

          <!-- Anúncios -->
          <div class="listing-card" *ngFor="let l of marketplace.listings; trackBy: trackByListing">
            <div class="listing-head">
              <strong>{{ l.marketplaceName }}</strong>
              <span [ngClass]="listingChipClass(l)" class="chip-sm">{{ l.listingStatusName }}</span>
            </div>
            <div class="listing-grid">
              <div><span class="lbl">SKU</span><span class="mono">{{ l.sku || '—' }}</span></div>
              <div><span class="lbl">ASIN</span><span class="mono">{{ l.externalId || '—' }}</span></div>
              <div><span class="lbl">Preço publicado</span><span>{{ l.publishedPrice != null ? formatCurrency(l.publishedPrice) : '—' }}</span></div>
              <div><span class="lbl">Solicitado em</span><span>{{ l.datetimeRequested ? (l.datetimeRequested | date:'dd/MM/yyyy HH:mm') : '—' }}</span></div>
              <div><span class="lbl">Publicado em</span><span>{{ l.datetimePublished ? (l.datetimePublished | date:'dd/MM/yyyy HH:mm') : '—' }}</span></div>
              <div><span class="lbl">Última sincronização</span><span>{{ l.datetimeLastSync ? (l.datetimeLastSync | date:'dd/MM/yyyy HH:mm') : '—' }}</span></div>
            </div>
            <div class="danger-alert" *ngIf="l.lastError" style="margin-top:10px;">
              <mat-icon style="font-size:18px;height:18px;width:18px;vertical-align:middle;margin-right:6px;">error</mat-icon>
              <strong>Erro na sincronização<span *ngIf="l.retryCount"> ({{ l.retryCount }} tentativa(s))</span>:</strong>
              {{ l.lastError }}
              <div style="margin-top:6px;font-size:.85rem;">
                Corrija os dados indicados (com a publicação desativada, se necessário) e clique em <em>Reprocessar</em>.
              </div>
            </div>
            <div class="listing-actions" *ngIf="l.canReprocess">
              <button mat-stroked-button color="primary" type="button" [disabled]="isTogglingMarketplace" (click)="reprocessListing(l)">
                <mat-icon>refresh</mat-icon> Reprocessar
              </button>
            </div>
          </div>

          <!-- Log de sincronização -->
          <h3 class="log-title">Log de sincronização</h3>
          <div *ngIf="!marketplace.logs?.length" class="subtitle">Nenhum evento de sincronização registrado.</div>
          <div class="log-table" *ngIf="marketplace.logs?.length">
            <div class="log-row log-header">
              <div>Data</div><div>Operação</div><div>Status</div><div>Mensagem</div>
            </div>
            <ng-container *ngFor="let g of marketplace.logs; trackBy: trackByLog">
              <div class="log-row">
                <div class="mono">{{ g.datetimeInclusion | date:'dd/MM/yyyy HH:mm:ss' }}</div>
                <div>{{ g.operationName }}<span *ngIf="g.idKitPayment" class="mono"> (venda #{{ g.idKitPayment }})</span></div>
                <div><span [ngClass]="logChipClass(g)" class="chip-sm">{{ g.syncStatusName }}</span></div>
                <div class="log-message">
                  {{ g.message }}
                  <button *ngIf="hasPayload(g)" type="button" class="link-btn" (click)="toggleLogPayload(g)">
                    {{ expandedLogId === g.idMarketplaceSyncLog ? 'ocultar detalhes' : 'ver detalhes' }}
                  </button>
                </div>
              </div>
              <div class="log-payload" *ngIf="expandedLogId === g.idMarketplaceSyncLog">
                <div *ngIf="g.requestPayload"><span class="lbl">Requisição</span><pre>{{ g.requestPayload }}</pre></div>
                <div *ngIf="g.responsePayload"><span class="lbl">Resposta</span><pre>{{ g.responsePayload }}</pre></div>
              </div>
            </ng-container>
          </div>
        </div>

        <!-- ========= KITS ========= -->
        <div class="section-kits">
          <h2 class="section-title">Kits de venda</h2>
          <p class="subtitle">Edite as combinações de itens disponíveis para venda</p>

          <div class="kit-item" *ngFor="let kit of kitRows; let i = index" [ngClass]="{ 'kit-disabled': !kit.isActive }">
            <div class="kit-row row g-3">

              <mat-form-field appearance="outline" class="field col-12 col-sm-6 col-md-3">
                <mat-label>Nome do kit</mat-label>
                <input matInput [(ngModel)]="kit.kitName" [ngModelOptions]="{ standalone: true }" name="kitName{{i}}"
                  [disabled]="isLockedByMarketplace" />
              </mat-form-field>

              <mat-form-field appearance="outline" class="field col-12 col-sm-6 col-md-3">
                <mat-label>Descrição</mat-label>
                <input matInput [(ngModel)]="kit.kitDescription" [ngModelOptions]="{ standalone: true }" name="kitDesc{{i}}"
                  [disabled]="isLockedByMarketplace" />
              </mat-form-field>

              <mat-form-field appearance="outline" class="field col-12 col-sm-6 col-md-3">
                <mat-label>Itens inclusos</mat-label>
                <mat-select multiple [(ngModel)]="kit.selectedItems" [ngModelOptions]="{ standalone: true }"
                  [disabled]="isLockedByMarketplace"
                  name="kitItems{{i}}" (selectionChange)="applyPriceGuards(kit)">
                  <mat-option value="book" [disabled]="!hasPrintPdfs">Livro físico</mat-option>
                  <mat-option value="ebook" [disabled]="!hasEbookPdf">E-book</mat-option>
                  <mat-option value="video" [disabled]="!hasAnyCourse">Curso / Vídeos</mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline" class="field col-12 col-sm-6 col-md-3">
                <mat-label>Valor total (R$)</mat-label>
                <input matInput [value]="formatCurrency(kit.totalPrice)" (keyup)="onCurrencyInput($event, kit)"
                  (blur)="onCurrencyBlur(kit)" name="kitTotal{{ i }}" [disabled]="isLockedByMarketplace" />
                <mat-hint>mín: {{ formatCurrency(getMinPriceForKit(kit)) }}</mat-hint>
              </mat-form-field>

              <div class="kit-actions col-12 col-sm-6 col-md-3">
                <mat-slide-toggle
                  [(ngModel)]="kit.isActive"
                  [ngModelOptions]="{ standalone: true }"
                  [disabled]="isLockedByMarketplace"
                  color="primary"
                  name="kitActive{{i}}">
                  {{ kit.isActive ? 'Ativo' : 'Inativo' }}
                </mat-slide-toggle>
                <button class="btn-add" type="button" *ngIf="!isLockedByMarketplace" (click)="addKit()" matTooltip="Adicionar kit">
                  <mat-icon>add</mat-icon>
                </button>
                <button class="btn-remove" type="button" *ngIf="kitRows.length > 1 && !isLockedByMarketplace" (click)="removeKit(i)"
                  matTooltip="Remover kit">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>

            </div>
          </div>
        </div>

        <!-- ========= AÇÕES ========= -->
        <div class="details-actions">
          <button class="continue-btn danger" type="button" (click)="goBack()">Voltar</button>

          <button class="continue-btn" type="submit" [disabled]="model.invalid || isSaving || isLockedByMarketplace"
            [matTooltip]="isLockedByMarketplace ? (marketplaceLockReason || '') : ''">
            <ng-container *ngIf="isSaving; else saveText">
              <mat-progress-spinner mode="indeterminate" diameter="18"></mat-progress-spinner>
            </ng-container>
            <ng-template #saveText>Salvar alterações</ng-template>
          </button>
        </div>

      </form>
    </ng-template>
  </div>
</div>

<app-footer></app-footer>
